var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 118,
  height: 120,
  viewBox: "0 0 118 120"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Lower_Layer_WooIcon",
  x: 0,
  y: 0,
  width: 114,
  height: 114,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: -2,
  dy: -3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#fff",
  floodOpacity: 0.478
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Upper_Layer_WooIcon",
  x: 4,
  y: 6,
  width: 114,
  height: 114,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur-2"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.239
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Woocommerce",
  transform: "translate(-1291 -1018)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 1291, 1018)",
  filter: "url(#Lower_Layer_WooIcon)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Lower_Layer_WooIcon-2",
  "data-name": "Lower_Layer_WooIcon",
  cx: 48,
  cy: 48,
  r: 48,
  transform: "translate(11 12)",
  fill: "#5e8e3e"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 1291, 1018)",
  filter: "url(#Upper_Layer_WooIcon)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Upper_Layer_WooIcon-2",
  "data-name": "Upper_Layer_WooIcon",
  cx: 48,
  cy: 48,
  r: 48,
  transform: "translate(11 12)",
  fill: "#7f54b3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5362",
  "data-name": "Group 5362",
  transform: "translate(2.249 0.314)"
}, /*#__PURE__*/React.createElement("path", {
  id: "WooLogo_Base",
  d: "M20.4,14.44H67.608a5.4,5.4,0,0,1,5.4,5.4v18.01a5.4,5.4,0,0,1-5.4,5.4H50.678L53,48.949l-10.228-5.7H20.395A5.4,5.4,0,0,1,15,37.854V19.844A5.4,5.4,0,0,1,20.4,14.44Z",
  transform: "translate(1303.751 1047.246)",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("g", {
  id: "WooLogo_Text",
  transform: "translate(1321.26 1064.827)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_371",
  "data-name": "Path 371",
  d: "M26.4,29.95a1.954,1.954,0,0,1,1.484-.733,1.758,1.758,0,0,1,2.073,1.7q1.114,7.417,2.386,12.593l5.2-9.881a2.258,2.258,0,0,1,1.783-1.415q1.562-.11,1.952,1.988a44.216,44.216,0,0,0,2.244,8.1q.936-9.027,3.125-13.052a1.826,1.826,0,0,1,1.566-1.05,2.084,2.084,0,0,1,1.5.468,1.826,1.826,0,0,1,.724,1.37,2.009,2.009,0,0,1-.228,1.141q-1.388,2.575-2.283,8.563a43.418,43.418,0,0,0-.653,9.043,2.883,2.883,0,0,1-.276,1.552,1.491,1.491,0,0,1-1.262.856,2.434,2.434,0,0,1-1.877-.879q-3.306-3.39-5.251-10.088-2.283,4.566-3.424,6.831-2.089,4.018-3.58,4.121-.968.068-1.648-1.625-1.826-4.65-3.918-17.994A2.027,2.027,0,0,1,26.4,29.95Z",
  transform: "translate(-25.993 -28.199)",
  fill: "#3c2861"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_372",
  "data-name": "Path 372",
  d: "M208.794,42.467a5.5,5.5,0,0,0-3.79-2.74,6.338,6.338,0,0,0-1.288-.137q-3.406,0-5.566,3.545a12.6,12.6,0,0,0-1.842,6.678,9.163,9.163,0,0,0,1.141,4.7,5.49,5.49,0,0,0,3.792,2.74,6.148,6.148,0,0,0,1.285.139q3.44,0,5.564-3.545a12.757,12.757,0,0,0,1.845-6.716A8.964,8.964,0,0,0,208.794,42.467ZM205.8,49.044a6.276,6.276,0,0,1-1.8,3.509,2.276,2.276,0,0,1-1.913.765q-.87-.174-1.395-1.534a6.122,6.122,0,0,1-.418-2.157,8.485,8.485,0,0,1,.173-1.74,7.822,7.822,0,0,1,1.251-2.817q1.183-1.737,2.47-1.459.87.176,1.393,1.53a6.116,6.116,0,0,1,.416,2.155,8.468,8.468,0,0,1-.174,1.749Z",
  transform: "translate(-157.426 -36.99)",
  fill: "#3c2861"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_373",
  "data-name": "Path 373",
  d: "M143.714,42.467a5.5,5.5,0,0,0-3.79-2.74,6.338,6.338,0,0,0-1.288-.137q-3.408,0-5.564,3.545a12.579,12.579,0,0,0-1.845,6.678,9.163,9.163,0,0,0,1.141,4.7,5.479,5.479,0,0,0,3.792,2.74,6.148,6.148,0,0,0,1.285.139q3.443,0,5.566-3.545a12.784,12.784,0,0,0,1.861-6.716,8.964,8.964,0,0,0-1.141-4.66Zm-2.991,6.577a6.265,6.265,0,0,1-1.808,3.513,2.279,2.279,0,0,1-1.913.765q-.868-.174-1.39-1.539a6.123,6.123,0,0,1-.418-2.157,8.483,8.483,0,0,1,.174-1.74,7.9,7.9,0,0,1,1.251-2.817q1.178-1.733,2.47-1.454.87.176,1.39,1.53A6.12,6.12,0,0,1,140.9,47.3a8.467,8.467,0,0,1-.173,1.74Z",
  transform: "translate(-107.203 -36.99)",
  fill: "#3c2861"
}))))));
export default __webpack_public_path__ + "static/media/wocommerce2.75947445.svg";
export { SvgComponent as ReactComponent };